import { liveQuoteTradeApiConnector } from 'apiConnector/secondary-market/live/trade';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, filter, map, mergeMap } from 'rxjs/operators';
import type { EpicWithThunk } from 'state/state.common';
import type { HttpError } from 'utils/http/httpClient.model';
import { extractHttpErrorMessage } from 'utils/http/httpClient.model';

import {
  secondaryMarketLiveQuoteCancelFailed,
  secondaryMarketLiveQuoteCancelReceived,
} from '../../../state/secondaryMarket/live/quote/liveQuote.action';

export function liveQuoteCancelRequestEpic(): EpicWithThunk {
  return (actions$, _state$, { httpClient, frontLogger }) =>
    actions$.pipe(
      ofType('SECONDARY_MARKET_LIVE_QUOTE_CANCEL_REQUESTED'),
      filter(a => a.shouldSendCancellation === true),
      mergeMap(({ quoteId }) => {
        return liveQuoteTradeApiConnector(httpClient)
          .cancelQuote(quoteId)
          .pipe(
            map(() => secondaryMarketLiveQuoteCancelReceived(quoteId)),
            catchError((error: HttpError) => {
              frontLogger.error('An error occurred inside cancelLiveTradeEpic {@FrontError}', error);
              return of(
                secondaryMarketLiveQuoteCancelFailed(quoteId, extractHttpErrorMessage(error, { backend: 'domino' })),
              );
            }),
          );
      }),
    );
}
